// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.diet-templates-page {
  padding: 30px;
  background-color: #A5D6A7;
  border-radius: 20px;
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.1);
  width: 90%;
  max-width: 1200px;
  margin: 50px auto;
  font-family: 'Rubik', sans-serif;
}

.menu-header {
  padding: 15px;
  border-bottom: 1px solid #eee;
  height: 60px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
}

.menu-header h3 {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  color: #333;
}

.action-buttons {
  display: flex;
  gap: 10px;
  justify-content: flex-end;
  flex-wrap: wrap;
}

.page-title {
  text-align: center;
  font-size: 32px !important;
  font-weight: 700;
  color: #333 !important;
  margin-bottom: 30px;
  margin-left: 250px; 
}

.template-container {
  display: flex;
  gap: 20px;
}

.template-menu {
  width: 250px;
  background: white;
  border-radius: 10px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  overflow: hidden;
  display: flex;
  flex-direction: column;
  height: 500px;
}

.scrollable-menu {
  flex: 1 1;
  overflow-y: auto;
  max-height: calc(500px - 60px);
  scrollbar-width: thin;
  scrollbar-color: #969292 #f1f1f1;
}

.scrollable-menu::-webkit-scrollbar {
  width: 8px;
}

.scrollable-menu::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 4px;
}

.scrollable-menu::-webkit-scrollbar-thumb {
  background-color: #388E3C;
  border-radius: 4px;
}

.scrollable-menu::-webkit-scrollbar-thumb:hover {
  background-color: #2E7D32;
}

.menu-item {
  padding: 12px 15px;
  cursor: pointer;
  transition: all 0.2s ease;
  border-bottom: 1px solid #eee;
}

.menu-item:hover {
  background-color: #f5f5f5;
}

.menu-item.active {
  background-color: #388E3C;
  color: white;
  font-weight: bold;
}

.template-content {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.btn-create,
.btn-edit,
.btn-delete,
.btn-save {
  display: inline-flex;
  align-items: center;
  gap: 8px; 
  justify-content: center;
}

.btn-create svg,
.btn-edit svg,
.btn-delete svg,
.btn-save svg {
  width: 16px;
  height: 16px;
}

.btn-create, .btn-edit, .btn-delete, .btn-save {
  padding: 10px 15px;
  font-size: 16px;
  font-weight: 600;
  border-radius: 10px;
  cursor: pointer;
  transition: all 0.3s ease;
}

.btn-create {
  background: #388E3C !important; 
  color: white;
  border: none;
  width: 150px;
}

.btn-edit {
  background: #1976D2; 
  color: white;
  border: none;
}

.btn-edit svg {
  margin-top: -3px;
}

.btn-delete {
  background: #dc3545 !important;
  color: white;
}

.btn-delete svg {
  margin-top: -3px;
}

.btn-save {
  background: #FF9800 !important; 
  color: white;
  border: none;
}

.btn-save svg {
  margin-top: -2px;
}

.btn-create:hover {
  background: #2E7D32; 
}

.btn-edit:hover {
  background: #1565C0; 
}

.btn-delete:hover {
  background: #B71C1C; 
}

.btn-save:hover {
  background: #F57C20; 
}

.template-details {
  flex: 1 1;
  padding: 20px;
  background: white;
  border-radius: 10px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.single-container h2 {
  color: #333;
  margin-bottom: 10px;
}

.single-container p {
  font-size: 16px;
  color: #555;
}

.diet-content h3 {
  margin-top: 15px;
  font-size: 18px;
  color: #222;
}

.diet-content p {
  font-size: 16px;
  color: #444;
  background: #f9f9f9;
  padding: 10px;
  border-radius: 5px;
  white-space: pre-wrap;
}

.info-text {
  text-align: center;
  font-size: 16px;
  color: #777;
  margin-top: 50px;
}

.diet-details-box {
  background: #f9f9f9;
  padding: 15px;
  border-radius: 5px;
  white-space: pre-wrap;
}

.success-message-container {
  position: fixed;
  top: 70px; 
  left: 0;
  right: 0;
  z-index: 1000;
  display: flex;
  justify-content: center;
  align-items: center;
  pointer-events: none; 
}

.success-message12 {
  color: #155724;
  background-color: #d4edda;
  border: 1px solid #c3e6cb;
  padding: 12px 20px;
  border-radius: 15px;
  font-weight: 600;
  box-shadow: 0 2px 10px rgba(0,0,0,0.1);
  display: inline-flex;
  align-items: center;
  max-width: 60% !important;
  text-align: center;
  animation: fadeInOut 3s ease-in-out forwards;
}

.error-message12 {
  color: #d32f2f;
  background-color: #fde7e9;
  border: 1px solid #d32f2f;
  padding: 12px;
  border-radius: 10px;
  display: flex !important;
  align-items: center !important;
  gap: 8px;
  margin: 10px auto !important; 
  font-weight: 600;
  width: 40%;
  justify-content: center !important;
  text-align: center;
}

@keyframes fadeInOut {
  0% { opacity: 0; transform: translateY(-20px); }
  10% { opacity: 1; transform: translateY(0); }
  90% { opacity: 1; transform: translateY(0); }
  100% { opacity: 0; transform: translateY(-20px); }
}  

/* Modal Styles */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.delete-modal {
  background-color: #A5D6A7;
  padding: 25px;
  border-radius: 8px;
  width: 400px;
  max-width: 90%;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
}

.delete-modal h3 {
  margin-top: 0;
  color: #d32f2f;
  font-size: 1.3rem;
}

.delete-modal p {
  margin: 15px 0 25px;
  color: #555;
}

.modal-buttons {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
}

.modal-button {
  padding: 8px 16px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-weight: 500;
  transition: all 0.2s ease;
}

.modal-cancel {
  background-color: #f0f0f0;
  color: #333;
}

.modal-cancel:hover {
  background-color: #e0e0e0;
}

.modal-confirm {
  background-color: #d32f2f;
  color: white;
}

.modal-confirm:hover {
  background-color: #b71c1c;
}`, "",{"version":3,"sources":["webpack://./src/styles/DietTemplatesPage.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,yCAAyC;EACzC,UAAU;EACV,iBAAiB;EACjB,iBAAiB;EACjB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,6BAA6B;EAC7B,YAAY;EACZ,sBAAsB;EACtB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,SAAS;EACT,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,0BAA0B;EAC1B,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,wCAAwC;EACxC,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,aAAa;AACf;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,8BAA8B;EAC9B,qBAAqB;EACrB,gCAAgC;AAClC;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;;;;EAIE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,uBAAuB;AACzB;;AAEA;;;;EAIE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;EAC9B,YAAY;EACZ,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,8BAA8B;EAC9B,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,8BAA8B;EAC9B,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,iBAAiB;EACjB,mBAAmB;EACnB,wCAAwC;AAC1C;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,eAAe;EACf,WAAW;EACX,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,SAAS;EACT,OAAO;EACP,QAAQ;EACR,aAAa;EACb,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,sCAAsC;EACtC,oBAAoB;EACpB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,4CAA4C;AAC9C;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,wBAAwB;EACxB,8BAA8B;EAC9B,QAAQ;EACR,4BAA4B;EAC5B,gBAAgB;EAChB,UAAU;EACV,kCAAkC;EAClC,kBAAkB;AACpB;;AAEA;EACE,KAAK,UAAU,EAAE,4BAA4B,EAAE;EAC/C,MAAM,UAAU,EAAE,wBAAwB,EAAE;EAC5C,MAAM,UAAU,EAAE,wBAAwB,EAAE;EAC5C,OAAO,UAAU,EAAE,4BAA4B,EAAE;AACnD;;AAEA,iBAAiB;AACjB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,oCAAoC;EACpC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,kBAAkB;EAClB,YAAY;EACZ,cAAc;EACd,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B","sourcesContent":[".diet-templates-page {\n  padding: 30px;\n  background-color: #A5D6A7;\n  border-radius: 20px;\n  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.1);\n  width: 90%;\n  max-width: 1200px;\n  margin: 50px auto;\n  font-family: 'Rubik', sans-serif;\n}\n\n.menu-header {\n  padding: 15px;\n  border-bottom: 1px solid #eee;\n  height: 60px;\n  box-sizing: border-box;\n  display: flex;\n  align-items: center;\n}\n\n.menu-header h3 {\n  margin: 0;\n  font-size: 18px;\n  font-weight: 600;\n  color: #333;\n}\n\n.action-buttons {\n  display: flex;\n  gap: 10px;\n  justify-content: flex-end;\n  flex-wrap: wrap;\n}\n\n.page-title {\n  text-align: center;\n  font-size: 32px !important;\n  font-weight: 700;\n  color: #333 !important;\n  margin-bottom: 30px;\n  margin-left: 250px; \n}\n\n.template-container {\n  display: flex;\n  gap: 20px;\n}\n\n.template-menu {\n  width: 250px;\n  background: white;\n  border-radius: 10px;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n  height: 500px;\n}\n\n.scrollable-menu {\n  flex: 1;\n  overflow-y: auto;\n  max-height: calc(500px - 60px);\n  scrollbar-width: thin;\n  scrollbar-color: #969292 #f1f1f1;\n}\n\n.scrollable-menu::-webkit-scrollbar {\n  width: 8px;\n}\n\n.scrollable-menu::-webkit-scrollbar-track {\n  background: #f1f1f1;\n  border-radius: 4px;\n}\n\n.scrollable-menu::-webkit-scrollbar-thumb {\n  background-color: #388E3C;\n  border-radius: 4px;\n}\n\n.scrollable-menu::-webkit-scrollbar-thumb:hover {\n  background-color: #2E7D32;\n}\n\n.menu-item {\n  padding: 12px 15px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  border-bottom: 1px solid #eee;\n}\n\n.menu-item:hover {\n  background-color: #f5f5f5;\n}\n\n.menu-item.active {\n  background-color: #388E3C;\n  color: white;\n  font-weight: bold;\n}\n\n.template-content {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n\n.btn-create,\n.btn-edit,\n.btn-delete,\n.btn-save {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px; \n  justify-content: center;\n}\n\n.btn-create svg,\n.btn-edit svg,\n.btn-delete svg,\n.btn-save svg {\n  width: 16px;\n  height: 16px;\n}\n\n.btn-create, .btn-edit, .btn-delete, .btn-save {\n  padding: 10px 15px;\n  font-size: 16px;\n  font-weight: 600;\n  border-radius: 10px;\n  cursor: pointer;\n  transition: all 0.3s ease;\n}\n\n.btn-create {\n  background: #388E3C !important; \n  color: white;\n  border: none;\n  width: 150px;\n}\n\n.btn-edit {\n  background: #1976D2; \n  color: white;\n  border: none;\n}\n\n.btn-edit svg {\n  margin-top: -3px;\n}\n\n.btn-delete {\n  background: #dc3545 !important;\n  color: white;\n}\n\n.btn-delete svg {\n  margin-top: -3px;\n}\n\n.btn-save {\n  background: #FF9800 !important; \n  color: white;\n  border: none;\n}\n\n.btn-save svg {\n  margin-top: -2px;\n}\n\n.btn-create:hover {\n  background: #2E7D32; \n}\n\n.btn-edit:hover {\n  background: #1565C0; \n}\n\n.btn-delete:hover {\n  background: #B71C1C; \n}\n\n.btn-save:hover {\n  background: #F57C20; \n}\n\n.template-details {\n  flex: 1;\n  padding: 20px;\n  background: white;\n  border-radius: 10px;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n}\n\n.single-container h2 {\n  color: #333;\n  margin-bottom: 10px;\n}\n\n.single-container p {\n  font-size: 16px;\n  color: #555;\n}\n\n.diet-content h3 {\n  margin-top: 15px;\n  font-size: 18px;\n  color: #222;\n}\n\n.diet-content p {\n  font-size: 16px;\n  color: #444;\n  background: #f9f9f9;\n  padding: 10px;\n  border-radius: 5px;\n  white-space: pre-wrap;\n}\n\n.info-text {\n  text-align: center;\n  font-size: 16px;\n  color: #777;\n  margin-top: 50px;\n}\n\n.diet-details-box {\n  background: #f9f9f9;\n  padding: 15px;\n  border-radius: 5px;\n  white-space: pre-wrap;\n}\n\n.success-message-container {\n  position: fixed;\n  top: 70px; \n  left: 0;\n  right: 0;\n  z-index: 1000;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  pointer-events: none; \n}\n\n.success-message12 {\n  color: #155724;\n  background-color: #d4edda;\n  border: 1px solid #c3e6cb;\n  padding: 12px 20px;\n  border-radius: 15px;\n  font-weight: 600;\n  box-shadow: 0 2px 10px rgba(0,0,0,0.1);\n  display: inline-flex;\n  align-items: center;\n  max-width: 60% !important;\n  text-align: center;\n  animation: fadeInOut 3s ease-in-out forwards;\n}\n\n.error-message12 {\n  color: #d32f2f;\n  background-color: #fde7e9;\n  border: 1px solid #d32f2f;\n  padding: 12px;\n  border-radius: 10px;\n  display: flex !important;\n  align-items: center !important;\n  gap: 8px;\n  margin: 10px auto !important; \n  font-weight: 600;\n  width: 40%;\n  justify-content: center !important;\n  text-align: center;\n}\n\n@keyframes fadeInOut {\n  0% { opacity: 0; transform: translateY(-20px); }\n  10% { opacity: 1; transform: translateY(0); }\n  90% { opacity: 1; transform: translateY(0); }\n  100% { opacity: 0; transform: translateY(-20px); }\n}  \n\n/* Modal Styles */\n.modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(0, 0, 0, 0.5);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1000;\n}\n\n.delete-modal {\n  background-color: #A5D6A7;\n  padding: 25px;\n  border-radius: 8px;\n  width: 400px;\n  max-width: 90%;\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);\n}\n\n.delete-modal h3 {\n  margin-top: 0;\n  color: #d32f2f;\n  font-size: 1.3rem;\n}\n\n.delete-modal p {\n  margin: 15px 0 25px;\n  color: #555;\n}\n\n.modal-buttons {\n  display: flex;\n  justify-content: flex-end;\n  gap: 12px;\n}\n\n.modal-button {\n  padding: 8px 16px;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  font-weight: 500;\n  transition: all 0.2s ease;\n}\n\n.modal-cancel {\n  background-color: #f0f0f0;\n  color: #333;\n}\n\n.modal-cancel:hover {\n  background-color: #e0e0e0;\n}\n\n.modal-confirm {\n  background-color: #d32f2f;\n  color: white;\n}\n\n.modal-confirm:hover {\n  background-color: #b71c1c;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
